import {LabelItem} from "../../../model/items/labelItem";
import m, {Vnode} from "mithril";
import Sortable from "sortablejs";
import MaxDiffCard from "./MaxDiffCard";
import MaxDiffDragdrop from "./MaxDiffDragdrop";

export default class MaxDiffDropTarget {

    constructor(
        private readonly label: LabelItem,
        private readonly rating: number,
        private readonly container: MaxDiffDragdrop,
    ) { }

    public view(): Vnode {
        const questionary = this.label.questionary;
        const items = this.container.state.getCurrentRowsWithRating(this.rating).map(row => m(new MaxDiffCard(this.container, row)));
        const touched = this.rating === this.container.touchingTarget;

        console.log(touched, this.rating, this.container.touchingTarget);

        return m('.target'+(items.length?'.has-items':'')+(touched?'.touched':'.untouched'), {
            'data-rating': this.rating,
        }, [
            m('label', {}, questionary.renderText(this.label.label ?? '')),
            m('.items', {
                oncreate: vnode => {
                    new Sortable(<HTMLElement>vnode.dom, {
                        group: {
                            name: 'MaxDiffDragdrop',
                            pull: false,
                        },
                        sort: false,
                        onAdd: e => {
                            const rowNumber = Number(e.item.dataset.row);
                            const row = this.container.state.rows.filter(r => r.label.cell.row === rowNumber)[0];
                            this.container.state.setValue(row, this.rating);
                            e.to.innerHTML = '';
                            this.container.forceRedrawWithTimeout();
                        },
                    })
                },
            }, items)
        ]);
    }
}